<template>
  <div class="vertical-offset2" />
</template>
